import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withJob } from 'react-jobs'
import { bindPromiseCreators } from '../../utils/routines'

import { withReducer } from './reducer'
import { withSaga } from './saga'
import { createSwitchLocalePromise } from './routines'
import { selectIntlLocale, selectIntlMessages, selectIntlFormats } from './selectors'

// connector
export const mapStateToProps = createStructuredSelector({
  locale: selectIntlLocale,
  messages: selectIntlMessages,
  formats: selectIntlFormats
})

export const mapDispatchToProps = bindPromiseCreators({
  switchLocale: createSwitchLocalePromise
})

const connector = connect(mapStateToProps, mapDispatchToProps)

// job
export function work(props) {
  return props.switchLocale(props.defaultLocale)
}
const job = withJob({ work })

// enhancer
const enhancer = compose(
  withReducer,
  withSaga,
  connector,
  job
)

export default enhancer
